<template>
  <v-container
    grid-list-xl
    fluid
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        md4>
        <v-text-field
          v-model="component.name"
          :error-messages="verrors('name')"
          label="Name"
          persistent-hint
          outline
        />
      </v-flex>

      <v-flex
        xs12
        md4>
        <v-text-field
          v-model="component.code"
          :error-messages="verrors('code')"
          label="Code"
          persistent-hint
          outline
        />
      </v-flex>

      <v-flex
        xs12
        md4>
        <v-select
          v-model="component.type"
          :items="['raw_html', 'json']"
          label="Type"
          outline
        />
      </v-flex>
      <v-flex xs12>
        <translations-tabs>
          <template #default="{language}">
            <translatable
              v-if="initialized && language"
              v-model="component"
              :language="language"
              field-name="content"
            >
              <template
                #default="{ fieldValue, fieldMutator, dynamicFieldValue }"
              >
                <monaco-editor
                  :theme="$vuetify.dark ? 'vs-dark' : 'vs-light'"
                  :content="fieldValue"
                  v-model="dynamicFieldValue"
                  :options="monacoOptions"
                  :language="component.type === 'json' ? 'json' : 'html'"
                  class="editor"
                  @change="fieldMutator(dynamicFieldValue)"
                />
              </template>
            </translatable>
          </template>
        </translations-tabs>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import MonacoEditor from 'vue-monaco'
import Translatable from '@/components/widgets/Translatable'
import TranslationsTabs from '@/components/widgets/TranslationsTabs'

export default {
  name: 'ComponentSingle',

  components: {
    TranslationsTabs,
    Translatable,
    MonacoEditor
  },

  actionBar () {
    return {
      title: 'Component',
      actions: [
        {
          text: 'Save',
          event: 'save'
        }
      ]
    }
  },

  data () {
    return {
      component: {
        content: '',
        name: '',
        code: ''
      },
      loading: false,
      initialized: false,
      monacoOptions: {
        minimap: {
          enabled: false
        }
      }
    }
  },

  computed: {
    verrors () {
      return field => {
        if (!this.component.errors) {
          return []
        }
        return this.component.errors
          .filter(obj => obj.field === field)
          .map(obj => obj.message)
          .flat()
      }
    },

    saveActionStates () {
      return {
        disabled: (this.component.errors && this.component.errors.length) || (this.component.isDirty && !this.component.isDirty()),
        loading: this.loading
      }
    }
  },

  async mounted () {
    this.loading = true
    if (this.$route.params.id) {
      this.component = await this.$http.make('component').find(this.$route.params.id, {
        headers: { 'x-template-code': this.$route.query.code }
      })
    }
    this.loading = false
    this.initialized = true
  },

  methods: {
    async onActionSave () {
      const code = this.$route.query.code
      this.loading = true
      await this.component.save({ headers: { 'x-template-code': code } })
      this.loading = false
    }
  }
}
</script>

<style>
.editor {
  width: 100%;
  min-height: 400px;
}
</style>
